import { createAsyncThunk } from "@reduxjs/toolkit";
import { MutationActionCreatorResult } from "@reduxjs/toolkit/query";
import { RootState } from "@/store/store";
import { infrastructureArchitectureRequestsPayloadSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureRequestsPayloadSelector";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import {
  cloudChiprApi,
  SolutionArchitectRequest,
} from "@/services/cloudchipr.api";
import { infrastructureArchitectureDiagramFixedCacheKey } from "@/store/infrastructure-architecture/utils/constants/constants";
import { infrastructureArchitectureSelectedResourceIdSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureSelectedResourceIdSelector";
import { getInfrastructureArchitectureRecommendationInFlightRequest } from "@/store/infrastructure-architecture/thunks/getInfrastructureArchitectureRecommendationThunk";
import { saveInfrastructureArchitectureStateInLocalStorageThunk } from "@/store/infrastructure-architecture/thunks/saveInfrastructureArchitectureStateInLocalStorageThunk";

let inFlightRequest: MutationActionCreatorResult<any> | null = null;

export const getInfrastructureArchitectureDiagramThunk = createAsyncThunk(
  "infrastructureArchitecture/getInfrastructureArchitectureDiagram",
  async (_, { getState, dispatch }) => {
    const state = getState() as RootState;
    const { postUsersMeSolutionArchitects } = cloudChiprApi.endpoints;

    const resourceId =
      infrastructureArchitectureSelectedResourceIdSelector(state);
    const payload = infrastructureArchitectureRequestsPayloadSelector(
      state,
    ) as SolutionArchitectRequest;

    if (!payload) {
      return;
    }

    if (inFlightRequest) {
      inFlightRequest.abort();
    }

    const recommendationRequest =
      getInfrastructureArchitectureRecommendationInFlightRequest();
    if (recommendationRequest) {
      recommendationRequest.abort();
    }

    inFlightRequest = dispatch(
      postUsersMeSolutionArchitects.initiate(
        {
          solutionArchitectRequest: payload,
        },
        {
          fixedCacheKey: `${infrastructureArchitectureDiagramFixedCacheKey}${resourceId ?? ""}`,
        },
      ),
    );

    try {
      const res = await inFlightRequest.unwrap();

      if (res) {
        dispatch(saveInfrastructureArchitectureStateInLocalStorageThunk());
      }

      return res;
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      if (e?.name === "AbortError") {
        return;
      }

      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
